import env from '../../../../environment';
import {
  postCreator,
  getCreator,
  putCreator,
  deleteCreator,
} from '../../../../http';

export const endpoints = Object.freeze({
  CREATE_TAG: `${env.baseApiUrl}/im/admin/crm-tag`,
  GET_TAGS: `${env.baseApiUrl}/im/admin/crm-tag`,
  EDIT_TAG: `${env.baseApiUrl}/im/admin/crm-tag/:tagId`,
  DELETE_TAG: `${env.baseApiUrl}/im/admin/crm-tag/:tagId`,
  UPDATE_CONVERSATION: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/:conversationId`,
});

export const createTag = postCreator(endpoints.CREATE_TAG);
export const getTags = getCreator(endpoints.GET_TAGS);
export const editTag = putCreator(endpoints.EDIT_TAG);
export const deleteTag = deleteCreator(endpoints.DELETE_TAG);

export const setTagToConversation = putCreator(endpoints.UPDATE_CONVERSATION);
export const setStateToConversation = putCreator(endpoints.UPDATE_CONVERSATION);
